/** Resolve a dot-delimited path on an object. */
export function getNested (obj, path) {
  if (obj == null || !path) return undefined
  const parts = String(path).split('.')
  let v = obj
  for (const p of parts) {
    v = v?.[p]
  }
  return v
}
